<script lang="ts">
import "@cisco-u/link/cu-link.js";

import { defineComponent } from "vue";

import SanitizeUrl from "@/utils/sanitizeUrl";

export default defineComponent({
  props: {
    url: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: undefined,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: undefined,
    },
    linkTitle: {
      type: String,
      default: undefined,
    },
    noUnderline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cleanUrl() {
      return SanitizeUrl(this.url);
    },
  },
});
</script>

<template>
  <cu-link
    :href="cleanUrl"
    tabindex="0"
    target="_blank"
    rel="noopener"
    :size="size"
    :dark="dark"
    :color="color"
    :linkTitle="linkTitle"
    :nounderline="noUnderline"
  >
    <slot />
  </cu-link>
</template>
